export default function() {
  return this._root;
}



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-quadtree/src/root.js
// module id = ../../../../d3-quadtree/src/root.js
// module chunks = 3